import { ConnectionStatus } from '@pflegia/types/common/enums/connection-status.enum';

export {
  /** @deprecated Import from @pflegia/types/common instead. */
  ConnectionStatus,
};
